import React from 'react';
import Swal from 'sweetalert2';

import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';



class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        municipiosVisita: []
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar el Municipio?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("municipios_visitas/borrar/"+id)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarMunicipiosVisita(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };

    ListarMunicipiosVisita(page){
        Swal.showLoading();
        let bname = document.getElementById('bnombre').value;
        if (bname == '') {
            bname = 0;
          }
        authAxios.get("municipios_visitas/index/"+bname+"?page=" + page)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', municipiosVisita: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
            })
        .catch(console.log);
        //window.location.href = '/'; window.localStorage.clear();
    }
    componentDidMount() {
        this.ListarMunicipiosVisita(1);
    }
    render() {
        const { load, municipiosVisita, pagina, ultimo, actual } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddMunicipiosVisita"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nuevo Municipio Visita</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista Municipios Visita</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-3">
                                    <input style={{textTransform: 'uppercase'}} type="text" id="bnombre" name="bnombre" placeholder="MUNICIPIO" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarMunicipiosVisita(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <table className="table table-hover table-condensed table-sm">
                                    <thead className="thead-inverse">
                                        <tr>
                                            <th className="align-middle">ID. MUNICIPIO</th>
                                            <th className="align-middle">MUNICIPIO</th>
                                            <th className="align-middle">ID. DEPARTAMENTO</th>
                                            <th className="align-middle">DEPARTAMENTO</th>
                                            <th className="align-middle">OPCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {load}
                                        {
                                            municipiosVisita.map((itemMunicipiosVisita) => (
                                                <tr key={itemMunicipiosVisita.id}>
                                                    <td>{itemMunicipiosVisita.ID_MUNICIPIO}</td>
                                                    <td>{itemMunicipiosVisita.municipio}</td>
                                                    <td>{itemMunicipiosVisita.ID_DEPARTAMENTO}</td>
                                                    <td>{itemMunicipiosVisita.departamento}</td>
                                                    <td>
                                                        <div className="btn-group" role="group" aria-label="">
                                                            <Link
                                                                className="btn btn-primary btn-sm"
                                                                to={"/UpMunicipiosVisita/" + itemMunicipiosVisita.id}
                                                            >
                                                                <FontAwesomeIcon icon={faEdit} />
                                                            </Link>&nbsp;&nbsp;
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() =>
                                                                    this.borrarRegistros(itemMunicipiosVisita.id)
                                                                }
                                                            >
                                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarMunicipiosVisita(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarMunicipiosVisita(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarMunicipioVisita(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarMunicipiosVisita(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarMunicipiosVisita(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;